"use client";
import { Collapsible as o } from "@ark-ui/react";
import { CollapsibleContext as c } from "@ark-ui/react";
import { collapsible as l } from "@huspy/styled-system/recipes";
import { createStyleContext as r } from "../../utils/createStyleContext.mjs";
const { withProvider: i, withContext: e } = r(l), n = i(o.Root, "root"), s = e(o.Content, "content"), a = e(o.Trigger, "trigger"), t = {
  Root: n,
  Content: s,
  Trigger: a
};
t.Root.displayName = "CollapsibleRoot";
t.Content.displayName = "CollapsibleContent";
t.Trigger.displayName = "CollapsibleTrigger";
export {
  t as Collapsible,
  s as Content,
  c as Context,
  n as Root,
  a as Trigger
};
